// extracted by mini-css-extract-plugin
module.exports = {"ContactForm":"ContactForm_ContactForm__2Iv7G","form":"ContactForm_form__1bsK4"};